<template>
  <div>
    <div class="box" @mousemove="isup=true" @mouseout="isup=false">
      <input type="text" @change="_upimg($event,types)">
      <!-- <div class="up" v-if="isup">+</div> -->
      <div class="imgbox">
        <img :src="src" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      srcs: require('../../../../common/img/culdefault.jpg'),
      isup: false,
      ids: '',
    };
  },
  props: {
    src: {
      type: String,
    },
    types: {
      type: String,
    },
    id: {
      type: String,
    },
  },
  methods: {},
};
</script>

<style scoped>
.box {
  position: relative;
  width: 320px;
  height: 240px;
  border: 1px solid #eaeaea;
}
input[type='text'] {
  opacity: 0;
  width: 320px;
  height: 240px;
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
}
.imgbox {
  width: 100%;
  height: 100%;
}
img {
  width: 100%;
  height: 100%;
}
.up {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 240px;
  font-size: 72px;
  font-weight: bold;
  line-height: 240px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
